import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"



import type { UploadedBatchEntry, UploadedRecordType } from '@/Services/Helper/bulk-csv-parser';
import { defineComponent, PropType } from 'vue';
import CorrectionEditorDrugTest, { DrugTestBatchEntry } from './CorrectionEditorDrugTest.vue';
import CorrectionEditorTreatment, { TreatmentBatchEntry } from './CorrectionEditorTreatment.vue';
import { MasterLookupWrapper } from '@/Models/Lookup/MasterLookupWrapper';
import { IProvider } from '@/Models/IProvider';

const __default__ = defineComponent({
	name: "data-correction-modal",
	props: {
		providedParsedData: {
			type: Object as PropType<UploadedBatchEntry>,
			required: true,
		},
		showDialog: {
			type: Boolean,
			required: true,
		},
		// assumes this MasterLookupWrapper has all of these lookups already populated:
		// LookupKeys.DrugTestMethod,
		// LookupKeys.DrugTestLocation,
		// LookupKeys.DrugTestSessionType,
		// LookupKeys.DrugTestType,
		// LookupKeys.DrugTestResult,
		// LookupKeys.DrugTestObservationType
		// LookupKeys.TreatmentStatus,
		// LookupKeys.TreatmentType,
		// we don't dynamically load them in each component due to the volume of data being
		// processed and wanting to not require a lookup call every time we go to edit a data row
		lookups: {
			type: Object as PropType<MasterLookupWrapper>,
			required: true,
		},
		providers: {
			type: Object as PropType<IProvider[]>,
			required: true,
		}
	},
	components: {
		CorrectionEditorDrugTest,
		CorrectionEditorTreatment,
	},
	created() {
		this.visible = this.showDialog;
		this.parsedData = this.providedParsedData;		
	},
	data: () => ({
		visible: false,
		
		// we get this data provided from a required prop and then watch it to update in place as necessary
		parsedData: {} as UploadedBatchEntry, 
	}),
	methods: {
		onClose(): void {
			this.$emit("close");
		},
		onUpdate(data: UploadedBatchEntry): void {
			this.$emit("update", data);
		}
	},
	computed: {
		editorType(): UploadedRecordType {
			return this.parsedData.type;
		}
	},
	watch: {
		providedParsedData(newVal: UploadedBatchEntry): void {
			this.parsedData = newVal;
		},
		showDialog(newVal: boolean): void {
			this.visible = newVal;
		}
	}
})


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  emits: ["close", "update"],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.editorType == 'drug test')
      ? (_openBlock(), _createBlock(CorrectionEditorDrugTest, {
          key: 0,
          onClose: _ctx.onClose,
          onUpdate: _ctx.onUpdate,
          showDialog: _ctx.visible,
          providedParsedData: _ctx.parsedData as DrugTestBatchEntry,
          lookups: _ctx.lookups
        }, null, 8, ["onClose", "onUpdate", "showDialog", "providedParsedData", "lookups"]))
      : _createCommentVNode("", true),
    (_ctx.editorType == 'treatment')
      ? (_openBlock(), _createBlock(CorrectionEditorTreatment, {
          key: 1,
          onClose: _ctx.onClose,
          onUpdate: _ctx.onUpdate,
          showDialog: _ctx.visible,
          providedParsedData: _ctx.parsedData as TreatmentBatchEntry,
          lookups: _ctx.lookups,
          providers: _ctx.providers
        }, null, 8, ["onClose", "onUpdate", "showDialog", "providedParsedData", "lookups", "providers"]))
      : _createCommentVNode("", true)
  ]))
}
}

})